(() => {
  function initializeEventRsvp(root = document) {
    const dialog = root.querySelector?.('[data-event-rsvp-dialog]') ||
      (root.matches?.('[data-event-rsvp-dialog]') ? root : null);
    if (!dialog || dialog.dataset.rsvpInitialized === 'true') return;

    dialog.dataset.rsvpInitialized = 'true';
    const openButtons = document.querySelectorAll('[data-event-rsvp-open]');
    const closeButton = dialog.querySelector('[data-event-rsvp-close]');

    openButtons.forEach((button) => button.addEventListener('click', () => dialog.showModal()));
    closeButton?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeEventRsvp());
  } else {
    initializeEventRsvp();
  }
  document.addEventListener('shopify:section:load', (event) => initializeEventRsvp(event.target));
})();
